import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SinglePageService} from "../../services/single-page.service";
import {DbValidators} from "../../../../shared/validators/DbValidators";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'db-single-page-creation-step',
    templateUrl: './single-page-creation-step.component.html',
    styleUrl: './single-page-creation-step.component.scss',
    standalone: false
})
export class SinglePageCreationStepComponent implements OnInit {
  pageForm: FormGroup = this._fb.group({
    title: ['', [DbValidators.trimStart, Validators.required]],
    description: ['', [DbValidators.trimStart, Validators.required, Validators.minLength(20)]]
  });
  @Output() onNext: EventEmitter<void> = new EventEmitter<void>();
  @Output() formTouched: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isMobile: boolean = false;

  constructor(private _fb: FormBuilder,
              private _route: ActivatedRoute,
              private singlePageService: SinglePageService) {
  }

  ngOnInit() {
    this._setFormValueFromQuery();
    const {pageForm} = this.singlePageService;
    if (pageForm) {
      this.pageForm.patchValue(pageForm);
    }
  }
  private _setFormValueFromQuery() {
    const query = this._route.snapshot.queryParamMap;
    const title = query.get('title');
    const description = query.get('description');
    if (title || description) {
      this.pageForm.patchValue({title, description});
      this.pageForm.markAsDirty();
    }
  }

  onClickNext() {
    this.formTouched.next(!this.pageForm.pristine);
    this.onNext.emit(this.pageForm.getRawValue());
    this.singlePageService.pageForm = this.pageForm.getRawValue();
    this.pageForm.markAsPristine();
  }
}
